import ENCHANTMENTS from "@/features/equipment/resources/midnight/enchantments";
import SOCKETS from "@/features/equipment/resources/midnight/sockets";

export default {
    SOCKET_LIST: SOCKETS,
    HEAD: {
        ENCHANTMENTS: ENCHANTMENTS.HEAD,
        SOCKET_CAN_BE_BOUGHT: false
    },
    NECK: {
        ENCHANTMENTS: [],
        SOCKET_CAN_BE_BOUGHT: true
    },
    SHOULDER: {
        ENCHANTMENTS: ENCHANTMENTS.SHOULDER,
        SOCKET_CAN_BE_BOUGHT: false
    },
    CHEST: {
        ENCHANTMENTS: ENCHANTMENTS.CHEST,
        SOCKET_CAN_BE_BOUGHT: false
    },
    BACK: {
        ENCHANTMENTS: [],
        SOCKET_CAN_BE_BOUGHT: false
    },
    WRIST: {
        ENCHANTMENTS: [],
        SOCKET_CAN_BE_BOUGHT: false
    },
    WAIST: {
        ENCHANTMENTS: [],
        SOCKET_CAN_BE_BOUGHT: false
    },
    LEGS: {
        ENCHANTMENTS: ENCHANTMENTS.LEGS,
        SOCKET_CAN_BE_BOUGHT: false
    },
    FEET: {
        ENCHANTMENTS: ENCHANTMENTS.FEET,
        SOCKET_CAN_BE_BOUGHT: false
    },
    FINGER_1: {
        ENCHANTMENTS: ENCHANTMENTS.FINGER,
        SOCKET_CAN_BE_BOUGHT: true
    },
    FINGER_2: {
        ENCHANTMENTS: ENCHANTMENTS.FINGER,
        SOCKET_CAN_BE_BOUGHT: true
    },
    MAIN_HAND: {
        ENCHANTMENTS: ENCHANTMENTS.WEAPON
    },
    OFF_HAND: {
        ENCHANTMENTS: ENCHANTMENTS.WEAPON
    },
    EXCEPTIONS: {}
};